import React from "react";
import HomeUI from "./HomeUI";
import useManifest from "../../hooks/useManifest";

export const Home = () => {
  const { articles, loading, error } = useManifest();

  return <HomeUI error={error} loading={loading} articles={articles} />;
};
